import { EffectCallback, useEffect, useRef } from 'react';

import { isEqual } from 'Shared/utils/object';

type Dependencies = Record<string, any>;

export function useDidUpdate(fn: EffectCallback, dependencies?: Dependencies) {
  const mounted = useRef(false);
  const previousDependencies = useRef<Dependencies | undefined>(undefined);

  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  useEffect(() => {
    if (mounted.current) {
      if (!isEqual(previousDependencies.current, dependencies)) {
        fn();
      }
    } else {
      mounted.current = true;
    }

    previousDependencies.current = dependencies;
  }, [fn, dependencies]);
}
